import React, { useEffect } from "react";
import { Button, Input, message, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { changePassword, showAuthLoader, userForget } from "../appRedux/actions/Auth";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "../components/CircularProgress/index";
import PhoneInput from "react-phone-input-2";
const ForgotPassword = (props) => {
  const dispatch = useDispatch();
  const {
    authUser,
    loader,
    alertMessage,
    showMessage,
    isReoveryFinished
  } = useSelector(({ auth }) => {
    return auth;
  });

  useEffect(() => {
    if (isReoveryFinished == true && authUser !== null) {
      props.history.push("/SignIn");
    }
  });
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = (values) => {
    if (values.MobileNumber) {
      values.MobileNumber = "0098" + values.MobileNumber
    }
    dispatch(showAuthLoader());
    dispatch(userForget(values));
  };
  const onFinishRecovert = (values) => {
    if (values.MobileNumber) {
      values.MobileNumber = "0098" + values.MobileNumber
    }
    dispatch(showAuthLoader());
    dispatch(changePassword(values));
  };
  return (
    <div className="gx-app-login-wrap">

      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-logo-content">
            <div className="gx-app-logo-content-bg">
              <img
                src={require("../../src/assets/images/sea.jpg").default}
                alt="Neature"
              />
            </div>
            <div className="gx-app-logo-wid">
              <h1>
                <IntlMessages id="app.userAuth.signIn" />
              </h1>
              <p>
                <IntlMessages id="app.userAuth.bySigning" />
              </p>
              <p>
                <IntlMessages id="app.userAuth.getAccount" />
              </p>
            </div>
            <div className="gx-app-logo">
              <img alt="example" src="/assets/images/logo.png" />
            </div>
          </div>

          {authUser && !isReoveryFinished ? (
            <div className="gx-app-login-content">
              <Form
                name="basic"
                onFinish={onFinishRecovert}
                onFinishFailed={onFinishFailed}
                className="gx-signin-form gx-form-row0"
              >
                {" "}
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "لطفا کد ارسال شده با وارد کنید",
                    },
                  ]}
                  name="Token"
                >
                  <Input placeholder="کد پیامک شده" />
                </Form.Item>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "کلمه عبور را وارد کنید",
                    },
                  ]}
                  name="Password"
                >
                  <Input type='password' placeholder="کلمه عبور" />
                </Form.Item>
                <Form.Item>
                  <Button type="primary" className="gx-mb-0" htmlType="submit">
                    تغییر رمز
                  </Button>
                </Form.Item>
              </Form>
            </div>) : (
            <div className="gx-app-login-content">
              <Form
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                className="gx-signin-form gx-form-row0"
              >
                <Form.Item
                  style={{ direction: "ltr" }}
                  initialValue="9"
                  rules={[{ required: true, message: "شماره موبایل را وارد کنید" }]}
                  name="MobileNumber"
                >
                 <PhoneInput disableDropdown={true} country={'ir'} onlyCountries={['ir']} disableCountryCode={true} placeholder="شماره موبایل" value="9"  />
                </Form.Item>
                <Form.Item>
                  <Button type="primary" className="gx-mb-0" htmlType="submit">
                    بازیابی
                  </Button>

                  
                  <Button ghost type="danger" ghost className="gx-mb-0" onClick={(e) => { props.history.push("/signin") }}>
                    <IntlMessages id="app.userAuth.signIn" />
                  </Button>
                </Form.Item>

              </Form>
            </div>
          )}
          {loader ? (
            <div className="gx-loader-view">
              <CircularProgress />
            </div>
          ) : null}
        </div>
      </div>

    </div>
  );
};
export default ForgotPassword;
